// Weekly trailer schedule shown on the Events page.
// Update this each week (or via chat) with where the trailer will be.
//
// Fields:
//   active — set false to hide the section entirely (e.g. quiet weeks)
//   note   — optional line shown under the heading (e.g. "Weather permitting")
//   stops  — one entry per outing:
//     day      — e.g. "Wednesday" (shown as the big label)
//     name     — event/market name
//     location — suburb/town or venue
//     time     — optional, e.g. "5pm – 9pm". Leave "" to hide.

export const TRAILER_SCHEDULE = {
  active: true,
  note: "Come find the trailer — rolled ice cream, loaded cookies and cookie pies on the go!",
  stops: [
    { day: "Wednesday", name: "Tokoroa Night Market", location: "Tokoroa", time: "" },
    { day: "Friday", name: "University Night Market", location: "Hamilton", time: "" },
    { day: "Saturday", name: "Tautoko Amateur Boxing Tournament", location: "Tokoroa", time: "" },
    { day: "Sunday", name: "Chartwell Night Market", location: "Chartwell, Hamilton", time: "" },
  ],
};
